import { ReactNode, createContext, useContext } from "react";
import { useFilterVisit } from "./filter-visit.hook";

const FilterVisitContext = createContext(
  {} as ReturnType<typeof useFilterVisit>
);
export function useFilterVisitContext() {
  return useContext(FilterVisitContext);
}

interface FilterVisitProviderProps {
  children: ReactNode;
}
export function FilterVisitProvider({
  children,
}: FilterVisitProviderProps) {
  return (
    <FilterVisitContext.Provider value={useFilterVisit()}>
      {children}
    </FilterVisitContext.Provider>
  );
}